

import firebase from 'firebase';

const config = { /* COPY THE ACTUAL CONFIG FROM FIREBASE CONSOLE */
  apiKey: "AIzaSyB_cYlhSzyDjXh0KLSZodd0Ke7RPvWiYUk",
  authDomain: "nlogn-5ee25.firebaseapp.com",
  databaseURL: "https://nlogn-5ee25.firebaseio.com",
  projectId: "nlogn-5ee25",
  storageBucket: "nlogn-5ee25.appspot.com",
  messagingSenderId: "52393768790",
  appId: "1:52393768790:web:b50ed0b5e0a2b39d8408f7",
  measurementId: "G-GB2DWJBSLC"
};

const fire = firebase.initializeApp(config);
export default fire;